<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
      <v-container class="text-center">
        <h1>Farm</h1>
        <v-text-field
          filled
          data-cy="FormFarm-name"
          :label="$$t('name')"
          v-model="localFarm.name"
        />
        <v-text-field
          filled
          data-cy="FormFarm-code"
          :label="$$t('code')"
          v-model="localFarm.code"
        />
        <v-text-field
          filled
          data-cy="FormFarm-number"
          :label="$$t('number')"
          v-model="localFarm.number"
        />
        <v-text-field
          filled
          data-cy="FormFarm-farmCode"
          :label="$$t('farmCode')"
          v-model="localFarm.farmCode"
        />
        <v-text-field
          filled
          data-cy="FormFarm-email"
          :label="$$t('email')"
          v-model="localFarm.email"
          :rules="[validation.rules.email]"
        />
        <v-text-field
          filled
          data-cy="FormFarm-address"
          :label="$$t('address')"
          v-model="localFarm.address"
        />
        <div class="d-flex justify-end mb-6">
          <v-btn color="default" outlined class="ml-4 btn-cancel" @click="cancel"
            data-cy="FormFarm-button-cancel">
            {{ $t('common.buttons.cancel') }}
          </v-btn>
          <v-btn color="primary" type="submit" class="ml-4" :loading="isLoading"
            data-cy="FormFarm-button-save">
              {{ $t('common.buttons.save') }}
            </v-btn>
        </div>
      </v-container>
  </v-form>
</template>

<script>
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'FormFarm',
  module: 'Farm',
  mixins: [loading],
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    Farm: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localFarm
      */
      localFarm: {},
    };
  },
  watch: {
    Farm() {
      this.localFarm = this.Farm;
    },
  },
  created() {
    this.localFarm = this.Farm;
  },
  methods: {
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        this.$emit('save', this.localFarm);
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<docs>
# FormFarm example

'''js
<FormFarm :Farm="Farm" />
'''
</docs>
